import React from 'react';

const ProductBundlesIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 0L0 5.93v12.14L12 24l12-5.93V5.93zm8.57 6.48l-3.19 1.57-8.51-4.27L12 2.24zM12 10.72L3.43 6.48 6.62 4.9l8.51 4.27zM2 8l9 4.45v8.81l-9-4.44zm11 13.27v-8.81L22 8v8.81z"/></svg>    )
};

export default ProductBundlesIcon;